<template>
  <div class="inputs">
    <Loading />
      <div class="col-12">
        <input type="text" v-on:keyup="entermonitor" v-model="usuario.acesso" id="usuario" class="form-control mb-3" placeholder="Usuário"/>
      </div>
      <div class="col-12">
      <input type="password" v-on:keyup="entermonitor" v-model="usuario.senha" id="senha" class="form-control mb-4" placeholder="Senha"/>
      </div>
      <div class="col-12">
        <button class="p-2 col-12 btn conectar text-white" type="button" :disabled="usuario.acesso == '' || usuario.senha == ''" @click="login(usuario)">Conectar</button>
      </div>
  </div>
</template>

<script>
  import RecSenha from './RecSenha';
  import Loading from './Loading';

  export default {
    name: 'Login',

    data() {
      return {
        usuario:{
          acesso: '',
          senha: '',
          lembrar: ''
        }
      }
    },

    components:{
      Loading
    },

    methods: {
      entermonitor: function(event) {
        if (event.key == "Enter") {
          if(this.usuario.acesso != '' && this.usuario.senha != ''){
            this.login(this.usuario)
          }
        }
      },

      login(usuario) {
        let thisVue = this;

        Store.dispatch('login', usuario)
                .then(resposta => {
                  if(resposta.response != '' && resposta.response != null && resposta.response != 'undefined' && resposta.response != undefined){
                    if(resposta.response.status == 401 || resposta.response.status == 422){
                      thisVue.$swal('Erro de Login', 'Usuário e/ou Senha incorretos', 'error');
                      return;
                    }else if(resposta.response.status != 200){
                      thisVue.$swal('Erro de conexão com o servidor', '', 'error');
                      return;
                    }
                  }

                  if(resposta.data.tsenha == 'true'){
                    thisVue.$parent.componente = RecSenha;
                    thisVue.$parent.login = false;
                    thisVue.$parent.usuario = thisVue.usuario;
                  }else{
                    let usuar = resposta.data.usuario;

                    Store.dispatch('configurarUsuario', usuar).then(function () {
                      thisVue.$router.push('/');
                    });
                  }
                })
                .catch(error => {
                  thisVue.$swal('Erro de conexão com o servidor', '', 'error');
                  console.log(error);
                })
      }
    }
  }
</script>

<style scoped>

  .conectar {
    background-color: #141E37;
    border-bottom: 4px solid #505a82;
  }
  button:hover {
        background-color: #030d26 !important;
  }
</style>
